export default __webpack_public_path__ + "static/media/trash.8129c9a7.svg";